// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Axiforma Regular";
  src: url("https://db.onlinewebfonts.com/t/ef3aab6eae44b00ed09594544784e6d8.eot");
  src: url("https://db.onlinewebfonts.com/t/ef3aab6eae44b00ed09594544784e6d8.eot?#iefix")
      format("embedded-opentype"),
    url("https://db.onlinewebfonts.com/t/ef3aab6eae44b00ed09594544784e6d8.woff2")
      format("woff2"),
    url("https://db.onlinewebfonts.com/t/ef3aab6eae44b00ed09594544784e6d8.woff")
      format("woff"),
    url("https://db.onlinewebfonts.com/t/ef3aab6eae44b00ed09594544784e6d8.ttf")
      format("truetype"),
    url("https://db.onlinewebfonts.com/t/ef3aab6eae44b00ed09594544784e6d8.svg#Axiforma Regular")
      format("svg");
}
body {
  margin: 0;
  font-family: "Axiforma Regular", sans-serif !important;
  padding-right: 0px !important;
}
.css-ahj2mt-MuiTypography-root {
  font-family: "Axiforma Regular", sans-serif !important;
}
h1,
h2,
h3,
h4,
h5,
h6,
body,
button,
input,
p,
span,
textarea {
  font-family: "Axiforma Regular", sans-serif !important;
}
.leftPaddingHome {
  padding-left: 13.5% !important;
}
.leftPaddingSolution {
  padding-left: 13.5% !important;
  margin-top: 2% !important;
}

.DownloadButton {
  color: #fff !important;
  letter-spacing: 2px !important;
  text-transform: capitalize !important;
  background-color: #1a1b1f !important;
  background-image: url("https://assets-global.website-files.com/646e79866091ec5584c257d3/646e79866091ec5584c257e9_Google%20Play%20logo.png"),
    url("https://assets-global.website-files.com/646e79866091ec5584c257d3/646e79866091ec5584c257e8_Apple%20logo.png");
  background-position: 20%, 10px !important;
  background-repeat: no-repeat, no-repeat !important;
  background-size: auto, auto !important;
  border-radius: 6px !important;
  padding: 5px 25px 5px 55px !important;
  font-size: 12px;
  font-weight: 300;
  line-height: 15px;
  transition: all 0.2s;
  margin-left: 10px !important;
}

@keyframes fadeIn {
  from {
    opacity: 0; /* Start fully transparent */
  }
  to {
    opacity: 1; /* Fade to fully opaque */
  }
}

.form-heading {
  animation: fadeIn 1s ease forwards; /* Apply the animation */
}
.form-field,
.india {
  animation: fadeIn 1.4s ease forwards; /* Apply the animation */
}

@keyframes leftToRight {
  from {
    opacity: 0;
    transform: translateX(-200px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes rightToLeft {
  from {
    opacity: 0;
    transform: translateX(200px);
  }
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}

@keyframes bottomToTop {
  from {
    opacity: 0;
    transform: translateY(100px);
  }
  to {
    opacity: 1;
    transform: translateY();
  }
}

@keyframes zoomIn {
  from {
    transform: scale(0); /* Start from no size */
  }
  to {
    transform: scale(1); /* Scale to original size */
  }
}
@keyframes topToBottom {
  from {
    opacity: 0;
    transform: translateY(-100px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.solution-desc {
  animation: leftToRight 0.8s ease forwards;
}
.box-heading {
  animation: zoomIn 1s ease forwards;
}
.solution-img {
  animation: zoomIn 1s ease forwards;
  max-width: 80% !important;
  margin-top: -10px !important;
  padding-right: 20px !important;
}
.line-img {
  width: 65% !important;
  text-align: "center";
}
.abha-subtitle,
.download-right {
  animation: leftToRight 1s ease forwards;
}

.abha-image,
.download-left {
  animation: rightToLeft 1s ease forwards;
}
.abha-image {
  max-width: 100% !important;
  margin-top: -10% !important;
  vertical-align: "middle" !important;
}
.contact-desc,
.form-title {
  animation: leftToRight 1.3s ease forwards;
}
.contact-info {
  animation: zoomIn 1.2s ease forwards;
  border: "0";
  width: 300px;
  height: 200px;
  border-radius: 15px;
  border: "1.12px solid #cfcfcf !important";
}

ul li,
.home-desc {
  opacity: 0;
  animation: leftToRight 0.8s ease forwards;
}
.sub-1-home {
  opacity: 0;
  animation: topToBottom 0.7s ease forwards;
}

ul li:nth-child(1) {
  animation-delay: 0.7s;
}
ul li:nth-child(2) {
  animation-delay: 0.9s;
}
ul li:nth-child(3) {
  animation-delay: 1.1s;
}
ul li:nth-child(4) {
  animation-delay: 1.3s;
}
ul li:nth-child(5) {
  animation-delay: 1.5s;
}

.box:nth-child(1),
.box:nth-child(4) {
  animation: leftToRight 1s ease forwards;
}
.box:nth-child(2) {
  animation: topToBottom 1s ease forwards;
}
.box:nth-child(3),
.box:nth-child(6) {
  animation: rightToLeft 1s ease forwards;
}
.box:nth-child(5) {
  animation: bottomToTop 1s ease forwards;
}

a:-webkit-any-link {
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,gFAAgF;EAChF;;;;;;;;;mBASiB;AACnB;AACA;EACE,SAAS;EACT,sDAAsD;EACtD,6BAA6B;AAC/B;AACA;EACE,sDAAsD;AACxD;AACA;;;;;;;;;;;;EAYE,sDAAsD;AACxD;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,qCAAqC;EACrC,oCAAoC;EACpC;qHACmH;EACnH,yCAAyC;EACzC,kDAAkD;EAClD,sCAAsC;EACtC,6BAA6B;EAC7B,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU,EAAE,4BAA4B;EAC1C;EACA;IACE,UAAU,EAAE,yBAAyB;EACvC;AACF;;AAEA;EACE,kCAAkC,EAAE,wBAAwB;AAC9D;AACA;;EAEE,oCAAoC,EAAE,wBAAwB;AAChE;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,mBAAmB,EAAE,uBAAuB;EAC9C;EACA;IACE,mBAAmB,EAAE,2BAA2B;EAClD;AACF;AACA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;AACA;;EAEE,uCAAuC;AACzC;;AAEA;;EAEE,uCAAuC;AACzC;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;AACrC;AACA;;EAEE,yCAAyC;AAC3C;AACA;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;;EAEE,UAAU;EACV,yCAAyC;AAC3C;AACA;EACE,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA;;EAEE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["@font-face {\n  font-family: \"Axiforma Regular\";\n  src: url(\"https://db.onlinewebfonts.com/t/ef3aab6eae44b00ed09594544784e6d8.eot\");\n  src: url(\"https://db.onlinewebfonts.com/t/ef3aab6eae44b00ed09594544784e6d8.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"https://db.onlinewebfonts.com/t/ef3aab6eae44b00ed09594544784e6d8.woff2\")\n      format(\"woff2\"),\n    url(\"https://db.onlinewebfonts.com/t/ef3aab6eae44b00ed09594544784e6d8.woff\")\n      format(\"woff\"),\n    url(\"https://db.onlinewebfonts.com/t/ef3aab6eae44b00ed09594544784e6d8.ttf\")\n      format(\"truetype\"),\n    url(\"https://db.onlinewebfonts.com/t/ef3aab6eae44b00ed09594544784e6d8.svg#Axiforma Regular\")\n      format(\"svg\");\n}\nbody {\n  margin: 0;\n  font-family: \"Axiforma Regular\", sans-serif !important;\n  padding-right: 0px !important;\n}\n.css-ahj2mt-MuiTypography-root {\n  font-family: \"Axiforma Regular\", sans-serif !important;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nbody,\nbutton,\ninput,\np,\nspan,\ntextarea {\n  font-family: \"Axiforma Regular\", sans-serif !important;\n}\n.leftPaddingHome {\n  padding-left: 13.5% !important;\n}\n.leftPaddingSolution {\n  padding-left: 13.5% !important;\n  margin-top: 2% !important;\n}\n\n.DownloadButton {\n  color: #fff !important;\n  letter-spacing: 2px !important;\n  text-transform: capitalize !important;\n  background-color: #1a1b1f !important;\n  background-image: url(\"https://assets-global.website-files.com/646e79866091ec5584c257d3/646e79866091ec5584c257e9_Google%20Play%20logo.png\"),\n    url(\"https://assets-global.website-files.com/646e79866091ec5584c257d3/646e79866091ec5584c257e8_Apple%20logo.png\");\n  background-position: 20%, 10px !important;\n  background-repeat: no-repeat, no-repeat !important;\n  background-size: auto, auto !important;\n  border-radius: 6px !important;\n  padding: 5px 25px 5px 55px !important;\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 15px;\n  transition: all 0.2s;\n  margin-left: 10px !important;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0; /* Start fully transparent */\n  }\n  to {\n    opacity: 1; /* Fade to fully opaque */\n  }\n}\n\n.form-heading {\n  animation: fadeIn 1s ease forwards; /* Apply the animation */\n}\n.form-field,\n.india {\n  animation: fadeIn 1.4s ease forwards; /* Apply the animation */\n}\n\n@keyframes leftToRight {\n  from {\n    opacity: 0;\n    transform: translateX(-200px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes rightToLeft {\n  from {\n    opacity: 0;\n    transform: translateX(200px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0px);\n  }\n}\n\n@keyframes bottomToTop {\n  from {\n    opacity: 0;\n    transform: translateY(100px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY();\n  }\n}\n\n@keyframes zoomIn {\n  from {\n    transform: scale(0); /* Start from no size */\n  }\n  to {\n    transform: scale(1); /* Scale to original size */\n  }\n}\n@keyframes topToBottom {\n  from {\n    opacity: 0;\n    transform: translateY(-100px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n.solution-desc {\n  animation: leftToRight 0.8s ease forwards;\n}\n.box-heading {\n  animation: zoomIn 1s ease forwards;\n}\n.solution-img {\n  animation: zoomIn 1s ease forwards;\n  max-width: 80% !important;\n  margin-top: -10px !important;\n  padding-right: 20px !important;\n}\n.line-img {\n  width: 65% !important;\n  text-align: \"center\";\n}\n.abha-subtitle,\n.download-right {\n  animation: leftToRight 1s ease forwards;\n}\n\n.abha-image,\n.download-left {\n  animation: rightToLeft 1s ease forwards;\n}\n.abha-image {\n  max-width: 100% !important;\n  margin-top: -10% !important;\n  vertical-align: \"middle\" !important;\n}\n.contact-desc,\n.form-title {\n  animation: leftToRight 1.3s ease forwards;\n}\n.contact-info {\n  animation: zoomIn 1.2s ease forwards;\n  border: \"0\";\n  width: 300px;\n  height: 200px;\n  border-radius: 15px;\n  border: \"1.12px solid #cfcfcf !important\";\n}\n\nul li,\n.home-desc {\n  opacity: 0;\n  animation: leftToRight 0.8s ease forwards;\n}\n.sub-1-home {\n  opacity: 0;\n  animation: topToBottom 0.7s ease forwards;\n}\n\nul li:nth-child(1) {\n  animation-delay: 0.7s;\n}\nul li:nth-child(2) {\n  animation-delay: 0.9s;\n}\nul li:nth-child(3) {\n  animation-delay: 1.1s;\n}\nul li:nth-child(4) {\n  animation-delay: 1.3s;\n}\nul li:nth-child(5) {\n  animation-delay: 1.5s;\n}\n\n.box:nth-child(1),\n.box:nth-child(4) {\n  animation: leftToRight 1s ease forwards;\n}\n.box:nth-child(2) {\n  animation: topToBottom 1s ease forwards;\n}\n.box:nth-child(3),\n.box:nth-child(6) {\n  animation: rightToLeft 1s ease forwards;\n}\n.box:nth-child(5) {\n  animation: bottomToTop 1s ease forwards;\n}\n\na:-webkit-any-link {\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
